<template>
  <v-layout>
    <v-layout column>
      <v-layout align-end>
        <h2 class="ml-2">
          Основные данные по Запросу
        </h2>
        <v-btn
          icon
          class="my-0"
        >
          <v-icon
            color="grey"
            @click="$emit('change', 1)"
          >
            edit
          </v-icon>
        </v-btn>
      </v-layout>
      <v-layout column>
        <v-flex>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="client"
            label="Клиент*"
            hide-details
            readonly
          />
        </v-flex>
        <v-flex>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="manager"
            label="Менеджер*"
            hide-details
            readonly
          />
        </v-flex>
      </v-layout>

      <v-layout
        align-end
        class="mt-3"
      >
        <h2 class="ml-2 mt-3">
          Первоначальное местонахождение груза
        </h2>
        <v-btn
          icon
          class="my-0"
        >
          <v-icon
            color="grey"
            @click="$emit('change', 2)"
          >
            edit
          </v-icon>
        </v-btn>
      </v-layout>
      <v-layout column>
        <v-layout>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="sendingCountry"
              label="Страна отправления*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="manufacturer"
              label="Производитель*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs6>
            <v-text-field
              class="ma-2"
              outline
              :value="clientAlias"
              label="Клиент по документам"
              hide-details
              readonly
              height="44"
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="factory"
              label="Продавец*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="region"
              label="Регион*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="loadingAddress"
              label="Адрес погрузки*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout
        align-end
        class="mt-3"
      >
        <h2 class="ml-2 mt-3">
          Характеристики товара
        </h2>
        <v-btn
          icon
          class="my-0"
        >
          <v-icon
            color="grey"
            @click="$emit('change', 3)"
          >
            edit
          </v-icon>
        </v-btn>
      </v-layout>
      <v-layout column>
        <v-layout>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="productCategory"
              label="Категория товара*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="generalProductDescription"
              label="Общее описание товара*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="productMaterial"
              label="Материал товара*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="usingSphere"
              label="Сфера применения*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
        <v-flex>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="productSite"
            label="Сайт товара*"
            hide-details
            readonly
          />
        </v-flex>
        <v-layout>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="readyDate"
              label="Дата готовности к отгрузке*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="wantedDate"
              label="Желаемая дата доставки*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="brutto"
              label="Вес брутто, кг*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="volume"
              label="Объем, м3*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="invoiceSum"
              label="Сумма инвойса*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="currency"
              label="Валюта*"
              hide-details
              readonly
            />
          </v-flex>
        </v-layout>
        <v-layout align-center>
          <v-flex xs4>
            <v-text-field
              class="ma-2"
              outline
              height="44"
              :value="needEx"
              label="Нужна ли Ex*"
              hide-details
              readonly
            />
          </v-flex>
          <v-flex xs3>
            <LabelSelectSimple
              v-model="entity.IsPayed"
              class="mx-2"
              title="Груз оплачен"
              readonly
              height="44"
            />
          </v-flex>
          <v-flex xs3>
            <LabelSelectComplex
              v-model="entity.Urgency"
              class="mx-2"
              title="Срочность"
              :items="[
                { id: 0, title: 'Стандартная' },
                { id: 1, title: 'Срочная' }
              ]"
              :colors="['green', 'red']"
              readonly
              height="44"
            />
          </v-flex>
          <v-flex xs3>
            <LabelSelectSimple
              v-model="entity.Oversized"
              class="mx-2"
              title="Негабарит"
              true-color="red"
              false-color="green"
              readonly
              height="44"
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <Packages
              v-model="entity.Packages"
              :is-shipping="true"
              :readonly="true"
            />
          </v-flex>
        </v-layout>
        <v-flex>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="cargoComment"
            label="Комментарии к размерам и кол-ву грузовых мест*"
            hide-details
            readonly
          />
        </v-flex>
      </v-layout>

      <v-layout
        align-end
        class="mt-3"
      >
        <h2 class="ml-2 mt-3">
          Адрес доставки товара
        </h2>
        <v-btn
          icon
          class="my-0"
        >
          <v-icon
            color="grey"
            @click="$emit('change', 4)"
          >
            edit
          </v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="shippingType"
            label="Тип поставки*"
            hide-details
            readonly
          />
        </v-flex>
        <v-flex>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="destinationCountry"
            label="Страна получателя по докам фабрики/отправителя*"
            hide-details
            readonly
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="unloadingCountry"
            label="Страна выгрузки*"
            hide-details
            readonly
          />
        </v-flex>
        <v-flex xs6>
          <v-text-field
            class="ma-2"
            outline
            height="44"
            :value="unloadingCity"
            label="Город выгрузки*"
            hide-details
            readonly
          />
        </v-flex>
      </v-layout>
      <v-flex>
        <v-text-field
          class="ma-2"
          outline
          height="44"
          :value="unloadingAddress"
          label="Адрес выгрузки*"
          hide-details
          readonly
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import LabelSelectSimple from "../../components/label/LabelSelectSimple.vue";
import LabelSelectComplex from "../../components/label/LabelSelectComplex.vue";
import Packages from "../shippings/components/new-shipping/Packages.vue";
export default {
  components: {
    LabelSelectSimple,
    LabelSelectComplex,
    Packages,
  },
  props: ["entity"],
  computed: {
    client() {
      return this.entity.Client ? this.entity.Client.title : "";
    },
    manager() {
      return this.entity.Employee ? this.entity.Employee.title : "";
    },
    sendingCountry() {
      return this.entity.SendingCountry ? this.entity.SendingCountry.title : "";
    },
    factory() {
      return this.entity.Factory ? this.entity.Factory.title : "";
    },
    manufacturer() {
      return this.entity.Manufacturer ? this.entity.Manufacturer.title : "";
    },
    region() {
      return this.entity.Region ? this.entity.Region.title : "";
    },
    loadingAddress() {
      return this.entity.LoadingAddress ? this.entity.LoadingAddress.title : "";
    },
    productCategory() {
      return this.entity.ProductCategory
        ? this.entity.ProductCategory.title
        : "";
    },
    generalProductDescription() {
      return this.entity.GeneralProductDescription
        ? this.entity.GeneralProductDescription
        : "";
    },
    productMaterial() {
      return this.entity.ProductMaterial ? this.entity.ProductMaterial : "";
    },
    usingSphere() {
      return this.entity.UsingSphere ? this.entity.UsingSphere : "";
    },
    productSite() {
      return this.entity.ProductSite ? this.entity.ProductSite : "";
    },
    readyDate() {
      return this.entity.ReadyDate
        ? this.moment(this.entity.ReadyDate).format("DD.MM.YY")
        : "";
    },
    wantedDate() {
      return this.entity.WantedDate
        ? this.moment(this.entity.WantedDate).format("DD.MM.YY")
        : "";
    },
    brutto() {
      return this.entity.Brutto ? this.entity.Brutto : "";
    },
    volume() {
      return this.entity.Volume ? this.entity.Volume : "";
    },
    unit() {
      return this.entity.Unit ? this.entity.Unit.title : "";
    },
    invoiceSum() {
      return this.entity.InvoiceSum ? this.entity.InvoiceSum : "";
    },
    currency() {
      return this.entity.Currency ? this.entity.Currency.title : "";
    },
    needEx() {
      return this.entity.NeedEx ? this.entity.NeedEx.title : "";
    },
    cargoComment() {
      return this.entity.CargoComment ? this.entity.CargoComment : "";
    },
    shippingType() {
      return this.entity.ShippingType ? this.entity.ShippingType.title : "";
    },
    destinationCountry() {
      return this.entity.DestinationCountry
        ? this.entity.DestinationCountry.title
        : "";
    },
    unloadingCountry() {
      return this.entity.UnloadingCountry
        ? this.entity.UnloadingCountry.title
        : "";
    },
    unloadingCity() {
      return this.entity.UnloadingCity ? this.entity.UnloadingCity.title : "";
    },
    unloadingAddress() {
      return this.entity.UnloadingAddress
        ? this.entity.UnloadingAddress.title
        : "";
    },
    clientAlias() {
      return this.entity.ClientAlias ? this.entity.ClientAlias : "";
    },
  },
};
</script>
>
